import {
    Datagrid,
    List,
    SelectInput,
    TextField, TextInput
} from "react-admin";

const CustomQuestionBankField = ({ record, source }) => {
    let value = record[source]
    return <span>{`${value ? 'Banco de questões do Juristta' : 'Meu banco de questões'}`}</span>
}


export function QuizAssessmentQuestionBankList(props) {
    const filters = [
        <TextInput
            source="name"
            clearAlwaysVisible={true}
            fullWidth
            label={'Pesquisar pelo nome...'}
            alwaysOn
        />, ,
        <SelectInput alwaysOn source="owner" label="Exibir" choices={[
            { id: 'mine', name: 'Meus bancos de questões' },
            { id: 'juristta', name: 'Bancos de questões do Juristta' },
            { id: 'all', name: 'Todos os bancos de Questões' },
        ]} />
    ];

    return (
        <>
            <List
                filters={filters}
                exporter={false}
                bulkActionButtons={false}
                filterDefaultValues={{
                    owner: 'mine'
                }}
                {...props}
            >
                <Datagrid rowClick={'edit'}>
                    <TextField source="name" label="Nome" />
                    <TextField source="description" label="Descrição" />
                    <TextField source="question_amount" align={'left'} label="Quantidade de questões" />
                    <CustomQuestionBankField source="isGeneral" align={'right'} label="Banco de Questão" />
                </Datagrid>
            </List>
        </>
    )
}
